import { observer } from 'mobx-react-lite';
import { useEffect, useMemo } from 'react';
import { BasePage, PageType } from 'src/components/BasePage';
import { FormioForm } from 'src/components/FormioForm/FormioForm';
import { Spinner } from 'src/components/Spinner/Spinner';
import { SettingsLicenseStore } from 'src/stores/SettingsStores/SettingsLicenseStore/SettingsLicenseStore';
import { CombinedLoadingStatus } from 'src/utils/mobx/CombinedLoadingStatus';
import styled from 'styled-components';

const store = SettingsLicenseStore;

export const LicenseKeyDetails = observer(() => {
    useEffect(() => {
        store.loadItem('');
        store.loadForm(store.itemDetailsFormKey);
        store.updateItemLoader.reset();

        return () => {
            store.itemLoader.reset();
            store.formLoader.reset();
            store.updateItemLoader.reset();
        };
    }, []);

    const loadingStatus = useMemo(() => {
        return new CombinedLoadingStatus([
            store.formLoader,
            store.itemLoader,
            store.updateItemLoader,
        ]);
    }, []);

    const licenseInfo = useMemo(() => {
        return store.updateItemLoader.data || store.currentItem;
    }, [store.currentItem, store.updateItemLoader.data]);

    if (loadingStatus.isLoading) {
        return <StyledSpinner />;
    }

    return (
        <BasePage pageName="application-license" type={PageType.FULL}>
            <FormioForm
                form={store.currentItemForm as any}
                submission={{ data: licenseInfo } as any}
                normalizeSubmission
                onSubmit={async (submission) => {
                    await store.update('', submission.data);
                }}
            />
        </BasePage>
    );
});

const StyledSpinner = styled(Spinner)`
    margin: 0 auto;
    display: block;
`;
